import React from "react";

const TopAlign = ({ width = 14, height = 14, selected }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5 0.5V1.5L0.5 1.5V0.5L14.5 0.5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 2.5V5.5H5.5V2.5L9.5 2.5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 6.5V9.5H5.5V6.5H9.5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 6.5V9.5H5.5V6.5H9.5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 10.5V13.5H5.5V10.5H9.5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 14.5V17.5H5.5V14.5H9.5Z"
        fill={selected ? "white" : "black"}
      />
    </svg>
  );
};

export default TopAlign;
